export default __webpack_public_path__ + "static/media/plus-sign.043f0afa.svg";